import { render, staticRenderFns } from "./AyudaReportePartes.vue?vue&type=template&id=bf448ad8&scoped=true"
import script from "./AyudaReportePartes.vue?vue&type=script&lang=js"
export * from "./AyudaReportePartes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf448ad8",
  null
  
)

export default component.exports